import './FormInput.css'

function FormInput({ type, label, id }){
    return(

        <div key={id} className="container-inputs">
            <label htmlFor={id} className='container-inputs--tittle'>{label}</label>
            <input 
                type={type}
                id={id}
                className='container-inputs--input' 
                autoComplete='off'
            />
        </div>

    )
}

export { FormInput }